import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { Edit, FileCode } from 'lucide-react';

export default function AdminPagesAuditTableSection({
  category,
  label,
  pages,
  accessBadgeClass,
  getStatusMeta,
  getRouteSlug,
  formatAuditUpdate,
  onEdit
}) {
  // Calculate total lines for this category
  const totalLines = pages?.reduce((sum, page) => sum + (page.lines || 0), 0) || 0;
  
  return (
    <div
      className="border rounded-lg overflow-hidden"
      data-testid={`site-pages-section-${category}`}
    >
      <div className="bg-muted/40 px-4 py-2 font-semibold flex items-center justify-between">
        <span>{label}</span>
        <span className="text-xs font-normal text-muted-foreground flex items-center gap-1">
          <FileCode className="h-3 w-3" />
          {totalLines.toLocaleString()} lignes
        </span>
      </div>
      <table className="w-full text-sm" data-testid={`site-pages-table-${category}`}>
        <thead className="bg-muted">
          <tr>
            <th className="px-4 py-2 text-left">Route</th>
            <th className="px-4 py-2 text-left">Page</th>
            <th className="px-4 py-2 text-left">Fichier</th>
            <th className="px-4 py-2 text-right">Lignes</th>
            <th className="px-4 py-2 text-left">Accès</th>
            <th className="px-4 py-2 text-left">Statut</th>
            <th className="px-4 py-2 text-left">Notes</th>
            <th className="px-4 py-2 text-left"></th>
          </tr>
        </thead>
        <tbody className="divide-y">
          {pages?.length ? (
            pages.map((page) => {
              const statusMeta = getStatusMeta(page.audit_status);
              const routeSlug = getRouteSlug(page.route);
              return (
                <tr key={page.route} data-testid={`site-page-row-${routeSlug}`}>
                  <td className="px-4 py-2 font-mono text-xs" data-testid={`site-page-route-${routeSlug}`}>{page.route}</td>
                  <td className="px-4 py-2" data-testid={`site-page-name-${routeSlug}`}>{page.name}</td>
                  <td className="px-4 py-2 font-mono text-xs text-muted-foreground">{page.file || '—'}</td>
                  <td className="px-4 py-2 text-right tabular-nums">
                    {page.lines ? (
                      <span className={page.lines > 500 ? 'text-amber-600 font-medium' : ''}>{page.lines}</span>
                    ) : '—'}
                  </td>
                  <td className="px-4 py-2" data-testid={`site-page-access-${routeSlug}`}>
                    <Badge className={accessBadgeClass(page.access)}>{page.access}</Badge>
                  </td>
                  <td className="px-4 py-2" data-testid={`site-page-status-${routeSlug}`}>
                    <Badge className={statusMeta.className}>{statusMeta.label}</Badge>
                  </td>
                  <td className="px-4 py-2 text-muted-foreground max-w-[150px] truncate" data-testid={`site-page-notes-${routeSlug}`} title={page.audit_notes}>
                    {page.audit_notes ? page.audit_notes : '—'}
                  </td>
                  <td className="px-4 py-2">
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => onEdit(page)}
                      data-testid={`site-page-edit-${routeSlug}`}
                    >
                      <Edit className="h-4 w-4" />
                    </Button>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td className="px-4 py-3 text-sm text-muted-foreground" colSpan={8} data-testid={`site-pages-empty-${category}`}>
                Aucune page dans cette catégorie pour les filtres sélectionnés.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}